import React from 'react';
import { CIRCUITS } from '../data/circuits';
import './Sidebar.css';

const DEITY_OPTIONS = [
  { id: 'all',       label_en: 'All',        label_hi: 'सभी' },
  { id: 'vishnu',    label_en: 'Vishnu',     label_hi: 'विष्णु' },
  { id: 'shiva',     label_en: 'Shiva',      label_hi: 'शिव' },
  { id: 'muruga',    label_en: 'Muruga',     label_hi: 'मुरुगा' },
  { id: 'navagraha', label_en: 'Navagraha',  label_hi: 'नवग्रह' },
];

const FAITH_CONFIG = {
  hindu:    { label_en: 'Hindu',    label_hi: 'हिंदू',  color: 'var(--hindu)' },
  buddhist: { label_en: 'Buddhist', label_hi: 'बौद्ध',  color: 'var(--buddhist)' },
  jain:     { label_en: 'Jain',     label_hi: 'जैन',    color: 'var(--jain)' },
};

export default function Sidebar({
  states, activeStateId, onStateSelect,
  isHome, onHomeSelect,
  activeCircuit, onCircuitSelect, onCircuitClear,
  faithSet, onFaithToggle,
  isHinduOnly, activeDeity, onDeitySelect,
  filterItems, filterMode, activeCity, onCitySelect,
  stats, lang, isOpen, onClose,
}) {
  const L = (en, hi) => lang === 'en' ? en : hi;
  const filterHeading  = filterMode === 'district' ? L('Filter by District','जिले के अनुसार') : L('Filter by City','शहर के अनुसार');
  const filterAllLabel = filterMode === 'district' ? L('All Districts','सभी जिले') : L('All Cities','सभी शहर');

  const getStateCount = (s) => {
    if (!faithSet || faithSet.size === 0 || faithSet.size === 3) return s.temple_count;
    let count = 0;
    if (faithSet.has('hindu'))    count += (s.hindu_count    || 0);
    if (faithSet.has('buddhist')) count += (s.buddhist_count || 0);
    if (faithSet.has('jain'))     count += (s.jain_count     || 0);
    return count;
  };

  return (
    <aside className={`sidebar${isOpen ? ' sidebar-open' : ''}`}>

      {/* Home */}
      <section className="sidebar-section sidebar-home-section">
        <button className={`home-btn${isHome ? ' active' : ''}`} onClick={onHomeSelect}>
          <span className="home-icon">⌂</span>
          {L('Home', 'होम')}
        </button>
      </section>

      {/* Pilgrimage Circuits */}
      <section className="sidebar-section">
        <h2 className="sidebar-heading">{L('Pilgrimage Circuits', 'तीर्थ परिपथ')}</h2>
        <div className="circuit-list">
          {CIRCUITS.map(c => (
            <button
              key={c.id}
              className={`circuit-btn${activeCircuit?.id === c.id ? ' active' : ''}`}
              onClick={() => activeCircuit?.id === c.id ? onCircuitClear() : onCircuitSelect(c)}
              style={{ '--c-color': c.color, '--c-bg': c.bgColor, '--c-border': c.borderColor }}
            >
              <span className="circuit-btn-icon">{c.icon}</span>
              <div className="circuit-btn-labels">
                <span className="circuit-btn-name">{L(c.name_en, c.name_hi)}</span>
                <span className="circuit-btn-tagline">{L(c.tagline_en, c.tagline_hi)}</span>
              </div>
            </button>
          ))}
        </div>
      </section>

      {/* State browsing filters — hidden in circuit mode */}
      {!activeCircuit && (
        <>
          <section className="sidebar-section">
            <h2 className="sidebar-heading">{L('Filter by Faith','धर्म के अनुसार')}</h2>
            <div className="faith-filters">
              {Object.entries(FAITH_CONFIG).map(([key, cfg]) => (
                <button key={key} className={`faith-chip faith-${key}${faithSet.has(key)?' active':''}`}
                  onClick={() => onFaithToggle(key)} style={{ '--faith-color': cfg.color }}>
                  <span className="faith-dot" />
                  {L(cfg.label_en, cfg.label_hi)}
                  {stats && <span className="faith-count">{key==='hindu'?stats.hindu:key==='buddhist'?stats.buddhist:stats.jain}</span>}
                </button>
              ))}
            </div>
          </section>

          {isHinduOnly && (
            <section className="sidebar-section">
              <h2 className="sidebar-heading">{L('Filter by Deity','देवता के अनुसार')}</h2>
              <div className="deity-filters">
                {DEITY_OPTIONS.map(d => (
                  <button key={d.id} className={`deity-btn${activeDeity===d.id?' active':''}`}
                    onClick={() => onDeitySelect(d.id)}>
                    {L(d.label_en, d.label_hi)}
                  </button>
                ))}
              </div>
            </section>
          )}

          <section className="sidebar-section">
            <h2 className="sidebar-heading">{L('Select State','राज्य चुनें')}</h2>
            <nav className="state-nav">
              {states.map(s => (
                <button key={s.id} className={`state-btn${s.id===activeStateId?' active':''}`} onClick={() => onStateSelect(s)}>
                  <span className="state-name">{L(s.name_en, s.name_hi)}</span>
                  <span className="state-count">{getStateCount(s)}</span>
                </button>
              ))}
            </nav>
          </section>

          {filterItems.length > 0 && (
            <section className="sidebar-section">
              <h2 className="sidebar-heading">{filterHeading}</h2>
              <div className="city-list">
                <button className={`city-btn${activeCity==='all'?' active':''}`} onClick={() => onCitySelect('all')}>{filterAllLabel}</button>
                {filterItems.map(item => (
                  <button key={item} className={`city-btn${activeCity===item?' active':''}`} onClick={() => onCitySelect(item)}>{item}</button>
                ))}
              </div>
            </section>
          )}
        </>
      )}
    </aside>
  );
}
